<template>
  <el-dialog
    class="dialog-smart-subscribe-success"
    :visible="isShowDialogSmartSubscribeSuccess"
    width="590px"
    :show-close="false"
  >
    <span slot="title" class="el-dialog__title"> <i class="iconfont icon-success-circular" />已订阅成功 </span>

    <div class="content">
      <div class="row">
        <div>订阅器设置为:</div>
        <div class="value"></div>
      </div>
      <div class="row">
        <div class="label">业务类型:</div>
        <div class="value">
          <span :key="key" v-for="(item, key) in checkedBusinesses">
            {{ item }}
            <span v-show="key !== checkedBusinesses.length - 1"> , </span>
          </span>
        </div>
      </div>
      <div class="row">
        <div class="label">地&emsp;&emsp;区:</div>
        <div class="value">
          <template v-if="businessAreaSelectedText.length === this.getAreaJson.length">
            <span>全国</span>
          </template>

          <template v-else>
            <span :key="key" v-for="(item, key) in businessAreaSelectedText">
              {{ item }}
              <span v-show="key !== businessAreaSelectedText.length - 1"> , </span>
            </span>
          </template>
        </div>
      </div>
      <div class="row">
        <div>如需查看请前往</div>
        <div class="value" style="margin-left: 10px">
          <a :href="SUBSCRIBE_CENTER_SUBSCRIBE_INFO_BIDDING_INFO_URL + '?id=' + smartSubscribeId" target="_blank">
            「会员中心 - 订阅信息页」
          </a>
        </div>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" plain @click="viewSubscriber">查看订阅器</el-button>
      <el-button @click="handleConfirm">我知道了</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { SUBSCRIBE_CENTER_SUBSCRIBE_INFO_BIDDING_INFO_URL } from "@/utils/constants/constants.menu";
import { getAreaJson } from "@/assets/areaJSON";

export default {
  name: "DialogSmartSubscribeSuccess",
  data() {
    return {
      SUBSCRIBE_CENTER_SUBSCRIBE_INFO_BIDDING_INFO_URL,
    };
  },
  computed: {
    getAreaJson,
    smartSubscribeId() {
      return this.$store.getters["industryZone/smartSubscribeId"];
    },
    isShowDialogSmartSubscribeSuccess() {
      return this.$store.getters["industryZone/isShowDialogSmartSubscribeSuccess"];
    },
    checkedBusinesses() {
      return this.$store.getters["industryZone/smartSubscribe"].businessCountData
        .filter((v) => v.checked)
        .reduce((prev, cur) => {
          prev.push(cur.businessName);
          return prev;
        }, []);
    },
    businessAreaSelectedText() {
      return this.$store.getters["industryZone/businessAreaSelected"].reduce((prev, cur) => {
        prev.push(cur.text);
        return prev;
      }, []);
    },
  },
  methods: {
    viewSubscriber() {
      window.open(this.SUBSCRIBE_CENTER_SUBSCRIBE_INFO_BIDDING_INFO_URL + "&subscribeId=" + this.smartSubscribeId);
      this.$store.commit("industryZone/updateIsShowDialogSmartSubscribeSuccess", false);
    },
    handleConfirm() {
      this.$store.commit("industryZone/updateIsShowDialogSmartSubscribeSuccess", false);
    },
  },
};
</script>

<style lang="scss">
@import "../../../../assets/config";

.dialog-smart-subscribe-success {
  .el-dialog__body {
    padding: 0 20px 20px 20px;
    color: $theme-font-color;
  }

  .el-dialog__title {
    display: flex;
    align-items: center;

    i {
      color: #00c700;
      font-size: 20px;
      margin-right: 5px;
    }
  }
}
</style>

<style scoped lang="scss">
@import "../../../../assets/config";

.content {
  padding: 0 24px;

  .row {
    margin-top: 20px;
    display: flex;

    .label {
      flex-shrink: 0;
      color: #595959;
    }

    .value {
      margin-left: 15px;

      //单行
      word-break: break-all;
      display: -webkit-box;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
    }

    a {
      color: $theme-color;
    }
  }
}
</style>
